import { CheckoutSelectionState } from "../../state/type";
import { OpenedPaymentMethod } from "./CheckoutPaymentMethod";

export function mapStateToInitOpenedPaymentMethod(state: CheckoutSelectionState["paymentMethod"]): OpenedPaymentMethod {
  if (state === null) {
    return null;
  }

  // FIXME ?
  // Payment methods are not synced to CTP so on init
  // they are not defined
  return null;
}
